import { ChangeEvent, useState } from "react";
import useSubmitMessages from "./useSubmitMessages";

function useForm<T>(initialValues: T) {
  const [formData, setFormData] = useState<T>(initialValues);
  const formMessages = useSubmitMessages();

  const onInputChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    formMessages.clearMessages();
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return {
    onInputChange,
    formMessages,
    formData
  }
}

export default useForm;